import { InvoiceDetailWidget } from "../../../Modules/Invoice/Widgets/InvoiceDetailWidget";

type OrderInvoiceTabProps = {
	invoiceId: number;
};

export function OrderInvoiceTab({ invoiceId }: OrderInvoiceTabProps) {
	return (
		<InvoiceDetailWidget invoiceId={invoiceId} showRegenerateInvoiceButton />
	);
}
